import { Navigate } from "react-router-dom";
import getDynamicRedirect from "../core/utils/getDynamicRedirect";

const DynamicHome = () => {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = auth?.profile_name ?? null;

  return <Navigate to={getDynamicRedirect(role)} replace />;
};

export default DynamicHome;
